<!-- Copyright 2025 Midas Healthcare Solutions - All Rights Reserved -->
<mat-form-field appearance="fill" *transloco="let t" style="width: 100%;">
  <mat-label>{{ t('Select Medication') }}</mat-label>
  <input matInput
         [formControl]="searchCtrl"
         [matAutocomplete]="auto"
         [placeholder]="getPlaceholderText()"
         (blur)="validateSelection()"/>
  
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option *ngFor="let nm of filteredItems | async" [value]="nm">
      {{ nm.medicationGroupDescription }}
    </mat-option>
    <mat-option *ngIf="(filteredItems | async)?.length === 0" [disabled]="true">
      {{ t('No Results') }}
    </mat-option>
  </mat-autocomplete>
  <button type="button"
          *ngIf="!disabled && (item || searchCtrl.value)"
          mat-icon-button
          matSuffix
          aria-label="Clear"
          (click)="clear()">
    <mat-icon>close</mat-icon>
  </button>
</mat-form-field>